import axios from 'axios';
import { createQuery } from 'react-query-kit';

import { appendEscapeParam, encodePathSegment, restUrl } from '@/services/utils';

export const useParentHierarchy = createQuery<any[], { primaryKey__: string; hierarchyName: string; }>({
    gcTime: 0,
    queryKey: ['parentHierarchy'],
    fetcher: async ({ primaryKey__ , hierarchyName}) => {
        const esc = '~';
        const url = appendEscapeParam(
            restUrl(`itemHierarchies/byItem/${encodePathSegment(primaryKey__, esc)}/parentHierarchyElements/${hierarchyName}`),
            esc, primaryKey__
        );
        const response = await axios.get(url);
        return response.data;
    }
});
